import {Injectable} from '@angular/core';

import {Storage} from '@ionic/storage';
import {Cookie} from 'ng2-cookies';

import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs";

@Injectable()
export class StorageService {

    constructor(public storage: Storage) {

    }

    out(observer: Observer<any>, key, value?, forceCookieToo?): void {

        //Null delete key
        if (value == null) {

            this.storage.remove(key)
                .then(data => {

                    if (forceCookieToo) { // usado em login para transmitir cookie para admin e connect-data.html

                        if (typeof value != 'string') value = JSON.stringify(value);
                        Cookie.set(key, value, 30 * 12, '/');

                    }

                })
                .catch(erro => {

                    if (typeof value != 'string') value = JSON.stringify(value);
                    Cookie.set(key, value, 30*12, '/');

                    observer.next(value);

                });

            return;
        }

        this.storage.set(key, value)
            .then(data => {

                if (forceCookieToo) { // usado em login para transmitir cookie para admin e connect-data.html

                    if (typeof value != 'string') value = JSON.stringify(value);
                    Cookie.set(key, value, 30 * 12, '/');

                }

                observer.next(data);

            })
            .catch(erro => {

                if (typeof value != 'string') value = JSON.stringify(value);
                Cookie.set(key, value, 30*12, '/');

                observer.next(value);

            });

    }

    set(keyOrObj, value?, forceCookieToo?): Observable<any> {

        return Observable.create(observer => {

            if (typeof keyOrObj == 'object') {

                for (let key in keyOrObj) {

                    this.out(observer, key, keyOrObj[key], forceCookieToo);

                }

                observer.complete();

            }
            else {

                this.out(observer, keyOrObj, value, forceCookieToo);

            }

        });

    }

    get(key): Observable<any> {

        return Observable.create(observer => {

            this.storage.get(key)
                .then((data) => {

                    observer.next(data);
                    observer.complete();

                }).catch(erro => {

                    let data = Cookie.get(key);

                    if (typeof data == 'string' && (data.substr(0, 1) == '{' || data.substr(0, 1) == '[')) {
                        data = JSON.parse(data);
                    }

                    observer.next(data);
                    observer.complete();

                });

        });

    }

}



// WEBPACK FOOTER //
// ./src/providers/storage-service.ts